/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

// External Imports
import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ClassAttendanceAuditRoute extends Route {
  // Attrs
  @service
  store;

  queryParams = {
    dateFrom: {
      refreshModel: true,
    },
    dateTo: {
      refreshModel: true,
    },
  };

  // State
  // dateFrom provides a setup binding for filtering to today's date when a
  // query param is not provided on the route.
  dateFrom = moment().format('YYYY-MM-DD');

  // dateTo provides a setup binding for filtering to today's date when a
  // query param is not provided on the route.
  dateTo = moment().format('YYYY-MM-DD');

  // Methods
  model(params) {
    let store = this.store;

    let dateFrom = params.dateFrom || this.dateFrom;
    let dateTo = params.dateTo || this.dateTo;

    return hash({
      registers: store.query('attendance/register', {
        dateFrom,
        dateTo,
      }),
      // Resolved to a plain array: the {{reverse}} template helper calls
      // A() on it, which throws on ember-data's live-array proxy.
      terms: this.store.findAll('term').then((terms) => terms.slice()),
    });
  }

  resetController() {
    this.controller.reset();
  }
}
